import React from 'react';
import Selection from "@molecules/selection/selection";
import {FilterDispatcherContext} from "@providers/filters";
import {UpdateSelectionOptions} from "@hooks/selection.options";
import {useWindowSize} from "@helpers/windows.size";

function VillaTypesSelection(props) {
    const windowSize = useWindowSize();
    const filterDispatcher = React.useContext(FilterDispatcherContext);
    let {show, options, selected_items} = props.items;

    function handleChange(data) {
        const new_option = UpdateSelectionOptions(options, data);
        filterDispatcher({
            type: 'VILLA_TYPE_OPTIONS',
            payload: new_option
        })
    }

    return (
        <div className={(show ? 'd-block' : 'd-none') + ' ' + (typeof props.className !== "undefined" ? props.className : '')}>
            <Selection
                type="single"
                name={props.name ?? "villa_type"}
                options={options}
                selected_items={selected_items}
                label="نوع ویلا"
                select_optional={(windowSize < 768)}
                onChange={(data) => handleChange(data)}
                showLabelAndSelected={!!(props.showLabelAndSelected)}
                loading={false}
            />
        </div>
    )
}

export default VillaTypesSelection;

// styles